import config from 'constants/config'

export function isLereEnabled() {
  return config.LERE_ENABLED
}
export function isLereHighIntentEnabled() {
  return config.LERE_HIGH_INTENT_ENABLED
}
export function isLereMetaSearchEnabled() {
  return !!config.LERE_META_SEARCH_ENABLED
}
